export const addOnOptions = [
    {name: 'Add Shrimp', price: 2},
    {name: 'Add Crab Meat', price: 2},
    {name: 'Add Scallops', price: 2},
    {name: 'Add Beef', price: 2},
    {name: 'Add Pork', price: 2},
    {name: 'Add Chicken', price: 2},
    {name: 'Add Vegetable', price: 1.5},
    {name: 'Add Broccoli', price: 1.5},
    {name: 'White Sauce', price: 0.5},
    {name: 'Add Spicy', price: 0.5}
];